/*!
 * @license
 * Copyright © 2005-2024 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
import { BaseApi } from './base.api';
import { throwIfNotDefined } from '../../../assert';
export class TaskFormsApi extends BaseApi {
    completeTaskForm(taskId, completeTaskFormRepresentation) {
        throwIfNotDefined(taskId, 'taskId');
        throwIfNotDefined(completeTaskFormRepresentation, 'completeTaskFormRepresentation');
        const pathParams = {
            taskId
        };
        return this.post({
            path: '/api/enterprise/task-forms/{taskId}',
            pathParams,
            bodyParam: completeTaskFormRepresentation
        });
    }
    getProcessInstanceVariables(taskId) {
        throwIfNotDefined(taskId, 'taskId');
        const pathParams = {
            taskId
        };
        return this.get({
            path: '/api/enterprise/task-forms/{taskId}/variables',
            pathParams
        });
    }
    getRestFieldColumnValues(taskId, field, column) {
        if (taskId === undefined || taskId === null) {
            throw new Error(`Missing param 'taskId' in getRestFieldValues`);
        }
        if (field === undefined || field === null) {
            throw new Error(`Missing param 'field' in getRestFieldValues`);
        }
        if (column === undefined || column === null) {
            throw new Error(`Missing param 'column' in getRestFieldValues`);
        }
        const pathParams = {
            taskId,
            field,
            column
        };
        return this.get({
            path: '/api/enterprise/task-forms/{taskId}/form-values/{field}/{column}',
            pathParams
        });
    }
    getRestFieldValues(taskId, field) {
        throwIfNotDefined(taskId, 'taskId');
        throwIfNotDefined(field, 'field');
        const pathParams = {
            taskId,
            field
        };
        return this.get({
            path: '/api/enterprise/task-forms/{taskId}/form-values/{field}',
            pathParams
        });
    }
    getTaskForm(taskId) {
        throwIfNotDefined(taskId, 'taskId');
        const pathParams = {
            taskId
        };
        return this.get({
            path: '/api/enterprise/task-forms/{taskId}',
            pathParams
        });
    }
    saveTaskForm(taskId, saveTaskFormRepresentation) {
        throwIfNotDefined(taskId, 'taskId');
        throwIfNotDefined(saveTaskFormRepresentation, 'saveTaskFormRepresentation');
        const pathParams = {
            taskId
        };
        return this.post({
            path: '/api/enterprise/task-forms/{taskId}/save-form',
            pathParams,
            bodyParam: saveTaskFormRepresentation
        });
    }
    getTaskFormVariables(taskId) {
        if (taskId === undefined || taskId === null) {
            throw new Error(`Missing param 'taskId' in getTaskFormVariables`);
        }
        const pathParams = {
            taskId
        };
        return this.get({
            path: '/api/enterprise/task-forms/{taskId}/variables',
            pathParams
        });
    }
}
